module.exports = __webpack_public_path__ + "assets/img/thumb-VentureCrowd-Article.11a2c755.jpg";